import React from 'react';
import { Handle, Position } from 'reactflow';

export default function TakeProfitNode({ data, id }) {
  const onChange = (field, value) => {
    if (data.onChange) data.onChange(id, field, value);
  };

  const mode = data.mode || 'percent';

  return (
    <div style={{
      padding: 12,
      borderRadius: 8,
      border: '2px solid #26a641',
      background: 'var(--card)',
      minWidth: 220,
      fontSize: 13,
      color: 'var(--text)',
    }}>
      <div style={{ fontWeight: 700, marginBottom: 8, color: '#26a641' }}>
        🎯 Take Profit
      </div>

      <div style={{ display: 'flex', gap: 6 }}>
        <select
          value={mode}
          onChange={(e) => onChange('mode', e.target.value)}
          style={{ flex: 1, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4 }}
        >
          <option value="percent">Percent</option>
          <option value="atr">ATR Multiple</option>
          <option value="risk_reward">Risk:Reward Multiple</option>
          <option value="pip">Pips (FX)</option>
        </select>
        <input
          type="number"
          min={0.1}
          step={mode === 'pip' ? 1 : 0.1}
          value={data.value ?? 4}
          onChange={(e) => onChange('value', parseFloat(e.target.value) || 0.1)}
          style={{ width: 70, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
        />
      </div>

      {mode === 'atr' && (
        <div style={{ marginTop: 6 }}>
          <label style={{ fontSize: 11, color: 'var(--muted)' }}>ATR period: </label>
          <input
            type="number"
            min={2}
            value={data.atr_period ?? 14}
            onChange={(e) => onChange('atr_period', Math.max(2, parseInt(e.target.value, 10) || 14))}
            style={{ width: 60, padding: 2, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
          />
        </div>
      )}

      {mode === 'pip' && (
        <div style={{ marginTop: 4, fontSize: 10, color: 'var(--muted)' }}>
          Target distance in pips. FX only (0.0001, or 0.01 for JPY pairs).
        </div>
      )}

      <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 6 }}>
        <label style={{ fontSize: 11, color: 'var(--muted)' }}>Close</label>
        <input
          type="number"
          min={0.1}
          max={100}
          step={5}
          value={data.size_pct ?? 100}
          onChange={(e) => onChange('size_pct', Math.max(0.1, Math.min(100, parseFloat(e.target.value) || 100)))}
          style={{ width: 60, padding: 4, background: 'var(--surface)', color: 'var(--text)', border: '1px solid var(--border)', borderRadius: 4, fontFamily: 'var(--font-mono)' }}
        />
        <label style={{ fontSize: 11, color: 'var(--muted)' }}>% of position</label>
      </div>

      <label style={{ display: 'flex', alignItems: 'center', gap: 6, marginTop: 8, fontSize: 11, color: 'var(--muted)' }}>
        <input
          type="checkbox"
          checked={!!data.move_stop_to_breakeven}
          onChange={(e) => onChange('move_stop_to_breakeven', e.target.checked)}
        />
        Move stop to breakeven after this fills
      </label>

      <div style={{ marginTop: 6, fontSize: 10, color: 'var(--muted)', lineHeight: 1.4 }}>
        Wire into a buy/short action's take-profit input. Set Close &lt; 100% and wire several
        take-profits into one action to scale out in stages. "Risk:Reward" mode needs a stop-loss on the same action.
      </div>

      <Handle type="source" position={Position.Right} id="output" style={{ background: '#26a641' }} />
    </div>
  );
}
